import React from 'react';
import profile from '../../assets/Images/about/intro.jpg';
export default function ShortPresentation(){
    return(
        <section class="about" id="about">
            <div class="aboutHeading">
                <h2>About me</h2>
            </div>
            <div class="about-image">
                <img src={profile} alt="Arturo Cesar Morales Montaño" onerror="this.style.display='none'"/>
            </div>
            <div class="about-content">
                <h3></h3>
                <p>
                    Software and Mechatronic Junior @ITESM CCM | Full-Stack Developer | Ecotivista (Founder) | 
                    Escuderia Borregos CCM - Electraton | Blue Force - Baja SAE | beVisioneers Fellow Cohort 2 | 
                    EGS Global 5th Generation Dandelion
                </p>
            </div>
        </section>
    )
}